import { isAdmin } from "../../../libs/common_utils";
import Registry from "../../../libs/register_storage";

/**
 * Custom React hook to determine if the current user has admin privileges.
 *
 * Retrieves the user's role from localStorage using the Registry utility,
 * constructs a user object, and checks if the user is an admin using the isAdmin function.
 *
 * @returns {boolean} true if the user is an admin, false otherwise.
 */
const useIsAdmin = () => {
  const storage = new Registry(window.localStorage);
  const user = { role: storage.getItem("user_role") };
  return isAdmin(user);
};

export default useIsAdmin;
